import type { HPConfirmationModalProps } from './HPConfirmationModal';

/** Static text props for HPConfirmationModal (everything except callbacks and state). */
export type ModalContent = Pick<
  HPConfirmationModalProps,
  'title' | 'bodyText' | 'warningText' | 'showDontShowAgain'
>;

export const DISCARD_CHANGES_MODAL: ModalContent = {
  title: 'Discard changes to this hanging protocol?',
  bodyText: 'If you cancel now, your unsaved changes will be lost.',
  showDontShowAgain: false,
};

export const RESET_ALL_MODAL: ModalContent = {
  title: 'Reset hanging protocol and steps?',
  bodyText: 'This will revert all unsaved changes to the last saved version.',
  showDontShowAgain: false,
};

/**
 * Shown before adding a new step while the currently active step has unsaved changes.
 * Adding a step in this state reverts the active step to its last-saved version
 * (createStepWithRevert) -- this confirms the user intends that before it happens,
 * rather than relying solely on the undo toast shown afterward (VX-4613).
 */
export const ADD_STEP_WITH_UNSAVED_CHANGES_MODAL: ModalContent = {
  title: 'Add step and discard unsaved changes?',
  bodyText:
    'The current step has unsaved changes. Adding a new step will discard them and reset this step to its last-saved version.',
  showDontShowAgain: false,
};

/**
 * Deleting a hanging protocol. A function rather than a constant because the copy names the protocol -- kept word for
 * word from the modal this replaced, so nothing about the decision the reader is making has changed.
 */
export const makeDeleteHPModalContent = (protocolName: string): ModalContent => ({
  title: 'Delete hanging protocol?',
  bodyText: `Are you sure you want to permanently delete "${protocolName}" hanging protocol?`,
  showDontShowAgain: false,
});
